import { Project } from "models"
import { AlertType } from 'react-alert'

export class Alert {
  type: AlertType
  message: string
  counter: number

  constructor (alert: Alert) {
    for (const property in alert) {
      this[property] = alert[property]
    }
  }
}

export enum ModalComponentKeyTypes {
  LOCATION_INPUT = 'locationInput',
  CONFIRM_DIALOG = 'confirmDialog',
  PROJECTS_FILTER = 'projectsFilter',
  HOTKEYS_LIST = 'hotkeysList'
}

export interface ModalDialogDetails {
  show?: boolean;
  title: string;
  description?: string;
  onSubmit?: Function;
  componentKey?: string;
  project?: Project
  submitText?: string
}
